import { DitapMask, NavigationHelpButton } from "@cesium/widgets";

/**
 * 도움말 단일 버튼 위젯.</br>
 * A single button widget for mouse usage instructions.
 * @extends NavigationHelpButton
 *
 * @alias DitapNavigationHelpButton
 * @constructor
 *
 * @param {object} options 아래 속성 포함 객체.</br>Object with the following properties:
 * @param {Element|string} options.container 위젯을 포함할 DOM 요소 또는 ID.</br>
 * The DOM element or ID that will contain the widget.
 *
 * @example
 * const viewer = new Ditap.DitapViewer("ditapContainer");
 * const container = viewer.container;
 *
 * const navigationHelpContainer= container.getElementsByClassName(
 *    "js-ditap-toolbal-top-btn2"
 *  )[0];
 *
 * new Ditap.DitapNavigationHelpButton({
 *   viewer: viewer,
 *   container: navigationHelpContainer,
 * });
 *
 */
class DitapNavigationHelpButton extends NavigationHelpButton {
  constructor(options) {
    super(options);

    const that = this;
    const container = options.container;
    const currentWidth = window.innerWidth;
    const viewer = options.viewer;
    const mobileContainer = viewer.mobileBtnContainer;

    // 도움말 버튼
    // options.container
    //   .getElementsByClassName("cesium-navigationHelpButton-wrapper")[0]
    //   .remove();

    const navigationHelpButton = document.createElement("button");
    navigationHelpButton.className = "ditap-help-btn";

    const li = document.createElement("li");
    li.classList.add("ditap-func-btn-item");
    if (currentWidth <= 600) {
      li.appendChild(navigationHelpButton);
      // mobileContainer.appendChild(li);
      mobileContainer.querySelector(".js-position-help").appendChild(li);
      navigationHelpButton.classList.add("ditap-mobile-btn");
    } else {
      navigationHelpButton.classList.add("ditap-toolbar-btn");
      container.appendChild(navigationHelpButton);
    }

    const imgButton = document.createElement("p");
    const p2 = document.createElement("p");

    imgButton.classList.add("ditap-function-btn-img");
    p2.classList.add("ditap-btn-tooltip");
    p2.textContent = "도움말";

    navigationHelpButton.appendChild(imgButton);
    navigationHelpButton.appendChild(p2);

    // options.container.appendChild(navigationHelpButton);

    // 도움말 팝업
    const helpPopup = document.createElement("div");
    const h2 = document.createElement("h2");
    const button = document.createElement("button");
    const div2 = document.createElement("div");
    const ul = document.createElement("ul");
    const li1 = document.createElement("li");
    const p3 = document.createElement("p");
    const p4 = document.createElement("p");
    const p5 = document.createElement("p");
    const li2 = document.createElement("li");
    const p6 = document.createElement("p");
    const p7 = document.createElement("p");
    const p8 = document.createElement("p");
    const li3 = document.createElement("li");
    const p9 = document.createElement("p");
    const p10 = document.createElement("p");
    const p11 = document.createElement("p");

    const div3 = document.createElement("div");

    const div6 = document.createElement("div");
    const div4 = document.createElement("button");
    const div5 = document.createElement("button");

    const div2touch = document.createElement("div");
    const ultouch = document.createElement("ul");
    const li1touch = document.createElement("li");
    const p3touch = document.createElement("p");
    const p4touch = document.createElement("p");
    const p5touch = document.createElement("p");
    const li2touch = document.createElement("li");
    const p6touch = document.createElement("p");
    const p7touch = document.createElement("p");
    const p8touch = document.createElement("p");
    const li3touch = document.createElement("li");
    const p9touch = document.createElement("p");
    const p10touch = document.createElement("p");
    const p11touch = document.createElement("p");

    const li4touch = document.createElement("li");
    const p15touch = document.createElement("p");
    const p16touch = document.createElement("p");
    const p17touch = document.createElement("p");
    const div3touch = document.createElement("div");

    const divContent1 = document.createElement("div");
    const divContent2 = document.createElement("div");
    const divContent3 = document.createElement("div");
    const divContent4 = document.createElement("div");
    const divContent5 = document.createElement("div");
    const divContent6 = document.createElement("div");
    const divContent7 = document.createElement("div");
    divContent1.classList.add("ditap-nav-content");
    divContent2.classList.add("ditap-nav-content");
    divContent3.classList.add("ditap-nav-content");
    divContent4.classList.add("ditap-nav-content");
    divContent5.classList.add("ditap-nav-content");
    divContent6.classList.add("ditap-nav-content");
    divContent7.classList.add("ditap-nav-content");

    helpPopup.classList.add(
      "ditap-card",
      "ditap-help-mobile",
      "ditap-card-mobile",
      "ditap-help-popup"
    );
    helpPopup.classList.add("hide");
    h2.classList.add("ditap-card-title");
    h2.textContent = "도움말";

    // 탭
    div6.classList.add("ditap-map-tap-wrap");
    div4.classList.add("ditap-map-tap", "on");
    div5.classList.add("ditap-map-tap");
    div4.textContent = "마우스";
    div5.textContent = "터치";
    div4.classList.add("ditap-custom-button");
    div5.classList.add("ditap-custom-button");

    // 마우스
    div2.classList.add("ditap-card-content");
    ul.classList.add("ditap-card-list");
    li1.classList.add("ditap-card-item");
    li1.classList.add("ditap-help-card-move");
    p3.classList.add("ditap-help-img");
    p4.classList.add("ditap-help-title");
    p4.textContent = "화면 이동";
    p5.classList.add("ditap-help-content");
    // p5.textContent = "왼쪽 버튼 클릭하고 드래그";
    const moLine1 = document.createElement("span");
    moLine1.textContent = "왼쪽 버튼 클릭하고";
    const moLine2 = document.createElement("span");
    moLine2.textContent = "드래그";
    p5.append(moLine1);
    p5.append(moLine2);

    li2.classList.add("ditap-card-item");
    li2.classList.add("ditap-help-card-zoom");
    p6.classList.add("ditap-help-img");
    p7.classList.add("ditap-help-title");
    p7.textContent = "확대/축소";
    p8.classList.add("ditap-help-content");
    // p8.textContent = "마우스 가운데 휠 스크롤";
    const zoLine1 = document.createElement("span");
    zoLine1.textContent = "마우스 가운데 휠";
    const zoLine2 = document.createElement("span");
    zoLine2.textContent = "스크롤";
    p8.append(zoLine1);
    p8.append(zoLine2);

    li3.classList.add("ditap-card-item");
    li3.classList.add("ditap-help-card-rotate");
    p9.classList.add("ditap-help-img");
    p10.classList.add("ditap-help-title");
    p10.textContent = "회전";
    p11.classList.add("ditap-help-content");
    // p11.textContent = "오른쪽 버튼 클릭하고 드래그";
    const roLine1 = document.createElement("span");
    roLine1.textContent = "마우스 가운데 휠";
    const roLine2 = document.createElement("span");
    roLine2.textContent = "스크롤";
    p11.append(roLine1);
    p11.append(roLine2);
    button.classList.add("ditap-popup-close-btn", "ditap-custom-button");
    div3.classList.add("ditap-card-map");

    // 터치
    div2touch.classList.add("ditap-card-content", "hide");
    ultouch.classList.add("ditap-card-list");
    li1touch.classList.add("ditap-card-item");
    // li1touch.classList.add("ditap-help-card-move");
    li1touch.classList.add("ditap-help-card-one-point");
    li1touch.classList.add("ditap-help-touch");

    p3touch.classList.add("ditap-help-img");
    p4touch.classList.add("ditap-help-title");
    p4touch.textContent = "화면 이동";
    p5touch.classList.add("ditap-help-content");
    // p5touch.textContent = "한 손가락으로 드래그";
    const movLine1 = document.createElement("span");
    movLine1.textContent = "한 손가락으로";
    const movLine2 = document.createElement("span");
    movLine2.textContent = "드래그";
    p5touch.append(movLine1);
    p5touch.append(movLine2);

    li2touch.classList.add("ditap-card-item");
    // li2touch.classList.add("ditap-help-card-zoom");
    li2touch.classList.add("ditap-help-card-pinch-point");
    li2touch.classList.add("ditap-help-touch");

    p6touch.classList.add("ditap-help-img");
    p7touch.classList.add("ditap-help-title");
    p7touch.textContent = "확대/축소";
    p8touch.classList.add("ditap-help-content");
    // p8touch.textContent = "두 손가락으로 핀치";
    const zoomLine1 = document.createElement("span");
    zoomLine1.textContent = "두 손가락으로";
    const zoomLine2 = document.createElement("span");
    zoomLine2.textContent = "핀치";
    p8touch.append(zoomLine1);
    p8touch.append(zoomLine2);

    li3touch.classList.add("ditap-card-item");
    // li3touch.classList.add("ditap-help-card-rotate");
    li3touch.classList.add("ditap-help-card-two-point");
    li3touch.classList.add("ditap-help-touch");

    p9touch.classList.add("ditap-help-img");
    p10touch.classList.add("ditap-help-title");
    p10touch.textContent = "기울이기";
    p11touch.classList.add("ditap-help-content");
    // p11touch.textContent = "두 손가락으로 같은 방향 드래그";
    const tiltLine1 = document.createElement("span");
    tiltLine1.textContent = "두 손가락으로";
    const tiltLine2 = document.createElement("span");
    tiltLine2.textContent = "같은 방향 드래그";
    p11touch.append(tiltLine1);
    p11touch.append(tiltLine2);

    li4touch.classList.add("ditap-card-item");
    // li4touch.classList.add("ditap-help-card-rotate");
    li4touch.classList.add("ditap-help-card-two-point");
    li4touch.classList.add("ditap-help-touch");

    p15touch.classList.add("ditap-help-img");
    p16touch.classList.add("ditap-help-title");
    p16touch.textContent = "회전";
    p17touch.classList.add("ditap-help-content");
    // p17touch.textContent = "두 손가락으로 다른 방향 드래그";
    const rotLine1 = document.createElement("span");
    rotLine1.textContent = "두 손가락으로";
    const rottLine2 = document.createElement("span");
    rottLine2.textContent = "다른 방향 드래그";
    p17touch.append(rotLine1);
    p17touch.append(rottLine2);

    div3touch.classList.add("ditap-card-map");

    div3.appendChild(h2);
    div3.appendChild(button);
    helpPopup.appendChild(div3);

    div6.append(div4);
    div6.append(div5);
    helpPopup.append(div6);

    helpPopup.appendChild(div2);
    div2.appendChild(ul);
    ul.appendChild(li1);
    ul.appendChild(li2);
    ul.appendChild(li3);
    li1.appendChild(p3);
    li1.appendChild(divContent1);
    divContent1.appendChild(p4);
    divContent1.appendChild(p5);

    li2.appendChild(p6);
    li2.appendChild(divContent2);
    divContent2.appendChild(p7);
    divContent2.appendChild(p8);

    li3.appendChild(p9);
    li3.appendChild(divContent3);
    divContent3.appendChild(p10);
    divContent3.appendChild(p11);

    helpPopup.appendChild(div2touch);
    div2touch.appendChild(ultouch);
    ultouch.appendChild(li1touch);
    ultouch.appendChild(li2touch);
    ultouch.appendChild(li3touch);
    ultouch.appendChild(li4touch);
    li1touch.appendChild(p3touch);
    li1touch.appendChild(divContent4);
    divContent4.appendChild(p4touch);
    divContent4.appendChild(p5touch);

    li2touch.appendChild(p6touch);
    li2touch.appendChild(divContent5);
    divContent5.appendChild(p7touch);
    divContent5.appendChild(p8touch);

    li3touch.appendChild(p9touch);
    li3touch.appendChild(divContent6);
    divContent6.appendChild(p10touch);
    divContent6.appendChild(p11touch);

    li4touch.appendChild(p15touch);
    li4touch.appendChild(divContent7);
    divContent7.appendChild(p16touch);
    divContent7.appendChild(p17touch);

    viewer.container.querySelector(".cesium-viewer").append(helpPopup);

    this._helpButton = navigationHelpButton;
    this._helpPopup = helpPopup;
    this._imgButton = imgButton;
    this.closeBtn = button;
    this._mouseTap = div4;
    this._touchTap = div5;
    this._mouseDiv = div2;
    this._touchDiv = div2touch;
    this.mask = new DitapMask();

    // 배경지도 팝업 여닫기
    navigationHelpButton.addEventListener("click", function () {
      viewer.clickToolbar(that);
    });

    // 헤더 닫기 버튼
    this.closeBtn.addEventListener("click", () => {
      viewer.clickToolbar(that);
    });

    const resizeOriginal = () => {
      // 윈도우의 현재 너비를 확인
      const currentWidth = window.innerWidth;
      if (currentWidth <= 600) {
        li.appendChild(navigationHelpButton);
        // mobileContainer.appendChild(li);
        mobileContainer.querySelector(".js-position-help").appendChild(li);
        navigationHelpButton.classList.add("ditap-mobile-btn");
        navigationHelpButton.classList.remove("ditap-toolbar-btn");
      } else {
        navigationHelpButton.style.display = "flex";
        navigationHelpButton.classList.remove("ditap-mobile-btn");
        navigationHelpButton.classList.add("ditap-toolbar-btn");
        container.appendChild(navigationHelpButton);
      }
    };
    this._resizeEvent = () => {
      resizeOriginal();
      setTimeout(resizeOriginal, 500);
    };

    window.addEventListener("resize", this._resizeEvent);

    this._touchTap.addEventListener(
      "click",
      (this.mapTabClickEvent = () => {
        this._mouseTap.classList.remove("on");
        this._touchTap.classList.add("on");

        // 지도 box 활성화
        this._touchDiv.classList.remove("hide");
        this._mouseDiv.classList.add("hide");
      })
    );

    this._mouseTap.addEventListener(
      "click",
      (this.terrainTabClickEvent = () => {
        this._touchTap.classList.remove("on");
        this._mouseTap.classList.add("on");

        // 터레인 box활성화
        this._mouseDiv.classList.remove("hide");
        this._touchDiv.classList.add("hide");
      })
    );

    super.destroy();
  }

  /*
   * 도움말 버튼 요소.</br>
   * The Element of helpButton.
   * @type {Element}
   */
  set helpButton(helpButton) {
    this._helpButton = helpButton;
  }
  get helpButton() {
    return this._helpButton;
  }

  /*
   * 도움말 팝업 요소.</br>
   * The Element of helpPopup
   * @type {Element}
   */
  set helpPopup(helpPopup) {
    this._helpPopup = helpPopup;
  }
  get helpPopup() {
    return this._helpPopup;
  }

  /*
   * 버튼 이미지 요소.</br>
   * The Element of imgButton
   * @type {Element}
   */
  set imgButton(imgButton) {
    this._imgButton = imgButton;
  }
  get imgButton() {
    return this._imgButton;
  }

  /**
   * 위젯 파괴. <br>
   * Destroys the widget.
   */
  destroy() {
    if (this._resizeEvent) {
      window.removeEventListener("resize", this._resizeEvent);
    }
    this._resizeEvent = undefined;
    this.closeBtn = undefined;
    this.isDestroyed = undefined;
    this._resizeEvent = undefined;
    this.mapTabClickEvent = undefined;
    this.throwOnDestroyed = undefined;
    this.terrainTabClickEvent = undefined;
    this._closeInstructions = undefined;
    this._container = undefined;
    this._helpButton = undefined;
    this._helpPopup = undefined;
    this._imgButton = undefined;
    this._mouseDiv = undefined;
    this._touchDiv = undefined;
    this._touchTap = undefined;
    this._viewModel = undefined;
    this._wrapper = undefined;
    this._mouseTap = undefined;
  }

  /**
   * 도움말 팝업 열기.</br>
   * Open NavigationHelp Popup
   */
  open() {
    this.mask.openMobile();
    this.helpPopup.classList.remove("hide");
    this.helpButton.classList.add("js-toolbar-on");
    this.imgButton.classList.add("on");
  }

  /**
   * 도움말 팝업 닫기.</br>
   * Close NavigationHelp Popup
   */
  close() {
    this.mask.closeMobile();

    this.helpPopup.classList.add("hide");
    this.helpButton.classList.remove("js-toolbar-on");
    this.imgButton.classList.remove("on");
  }
}
export default DitapNavigationHelpButton;
